import fluid, { extract, screens, fontSize } from 'fluid-tailwind';

export default {
    content: {
        files: [
            './custom/blocks/**/*.{js,php}',
            './custom/templates/**/*.twig',
            './ecmascript/**/*.js',
        ],
        extract,
    },
    theme: {
        screens,
        fontSize,
        colors: {
            transparent: 'transparent',
            current: 'currentColor',
            blue: '#1f366b',
            'blue-water': '#14213e',
            'blue-dark': '#000a21',
            white: '#fffcf5',
            'light-gray': '#e5e9f0',
            yellow: '#f4cd2f',
            red: '#a64200',
        },
        fontFamily: {
            display: ['halyard-display', 'sans-serif'],
            text: ['halyard-text', 'sans-serif'],
            micro: ['halyard-micro', 'sans-serif'],
        },
        extend: {
            screens: {
                xs: '26.875rem', // 430px
                '3xl': '120rem', // 1920px
            },
            borderWidth: {
                '10': '10px',
            },
        },
    },
    plugins: [
        require('@tailwindcss/container-queries'),
        fluid,
    ],
}

